import { NumeroriGjinia, NumeroriKategoria, NumeroriLloji, NumeroriRasa, NumeroriShoqerimi } from "@core/enums/numerori.enum";

export class NumeroriConstanst {

  public static NumeroriGjinia = [
    { id: 10, short: "m.", long: "Mashkullore" },
    { id: 11, short: "f.", long: "Femërore" },
  ];

  public static NumeroriLloji = [
    { id: 10, short: "m.", long: "i mirëfilltë" },
    { id: 11, short: "t.", long: "i tërësisë" },
  ];

  public static NumeroriLlojiIMirefillte = [
    { id: 10, short: "m.", long: "i mirëfilltë" }
  ];

  public static NumeroriLlojiITeresise = [
    { id: 11, short: "t.", long: "i tërësisë" }
  ];

  public static NumeroriRasa = [
    { id: 10, short: "E.", long: "Emërore" },
    { id: 11, short: "Gj. (i ...)", long: "Gjinore (i,e,të,së)" },
    { id: 12, short: "Dh.", long: "Dhanore" },
    { id: 13, short: "K.", long: "Kallëzore" },
    { id: 14, short: "Rr. (prej ...)", long: "Rrjedhore (prej ...)" },
  ];

  public static NumeroriShoqerimi = [
    { id: 10, short: "e.", long: "i shoqëruar me emër" },
    { id: 11, short: "p.", long: "i pashoqëruar me emër" },
  ];

  public static NumeroriShoqerimiMeEmer = [
    { id: 10, short: "e.", long: "i shoqëruar me emër" }
  ];

  public static NumeroriShoqerimiPaEmer = [
    { id: 11, short: "p.", long: "i pashoqëruar me emër" },
  ];


  public static NumeroriKategoria = [
    { id: 10, short: "1.", long: "1" },
    { id: 11, short: "2.", long: "2" },
    { id: 12, short: "3.", long: "3" },
    { id: 21, short: "4.", long: "4" },
    { id: 13, short: "6.", long: "6" },
    { id: 14, short: "20.", long: "20" },
    { id: 15, short: "21.", long: "21" },
    { id: 16, short: "22.", long: "22" },
    { id: 17, short: "23.", long: "23" },
    { id: 22, short: "24.", long: "24" },
    { id: 18, short: "26.", long: "26" },
    { id: 19, short: "Th. nj.", long: "Thyesat me numërues një" },
    { id: 20, short: "Th. d. s.", long: "Thyesat me numërues dy e sipër" },
  ];

  public static NumeroriStructure = [
    { llojiId: NumeroriLloji.Teresor, shoqerimiId: NumeroriShoqerimi.Ishoqeruarmeemer, gjiniaId: NumeroriGjinia.Mashkullore, left: 'të' },
    { llojiId: NumeroriLloji.Teresor, shoqerimiId: NumeroriShoqerimi.Ishoqeruarmeemer, gjiniaId: NumeroriGjinia.Femerore, left: 'të' },

    { llojiId: NumeroriLloji.Teresor, shoqerimiId: NumeroriShoqerimi.Ipashoqeruarmeemer, gjiniaId: NumeroriGjinia.Mashkullore, rasaId: NumeroriRasa.Emerore, left: 'të' },
    { llojiId: NumeroriLloji.Teresor, shoqerimiId: NumeroriShoqerimi.Ipashoqeruarmeemer, gjiniaId: NumeroriGjinia.Mashkullore, rasaId: NumeroriRasa.Gjinore, left: 'të' },
    { llojiId: NumeroriLloji.Teresor, shoqerimiId: NumeroriShoqerimi.Ipashoqeruarmeemer, gjiniaId: NumeroriGjinia.Mashkullore, rasaId: NumeroriRasa.Dhanore, left: 'të' },
    { llojiId: NumeroriLloji.Teresor, shoqerimiId: NumeroriShoqerimi.Ipashoqeruarmeemer, gjiniaId: NumeroriGjinia.Mashkullore, rasaId: NumeroriRasa.Kallezore, left: 'të' },
    { llojiId: NumeroriLloji.Teresor, shoqerimiId: NumeroriShoqerimi.Ipashoqeruarmeemer, gjiniaId: NumeroriGjinia.Mashkullore, rasaId: NumeroriRasa.Rrjedhore, left: 'të' },

    { llojiId: NumeroriLloji.Teresor, shoqerimiId: NumeroriShoqerimi.Ipashoqeruarmeemer, gjiniaId: NumeroriGjinia.Femerore, rasaId: NumeroriRasa.Emerore, left: 'të' },
    { llojiId: NumeroriLloji.Teresor, shoqerimiId: NumeroriShoqerimi.Ipashoqeruarmeemer, gjiniaId: NumeroriGjinia.Femerore, rasaId: NumeroriRasa.Gjinore, left: 'të' },
    { llojiId: NumeroriLloji.Teresor, shoqerimiId: NumeroriShoqerimi.Ipashoqeruarmeemer, gjiniaId: NumeroriGjinia.Femerore, rasaId: NumeroriRasa.Dhanore, left: 'të' },
    { llojiId: NumeroriLloji.Teresor, shoqerimiId: NumeroriShoqerimi.Ipashoqeruarmeemer, gjiniaId: NumeroriGjinia.Femerore, rasaId: NumeroriRasa.Kallezore, left: 'të' },
    { llojiId: NumeroriLloji.Teresor, shoqerimiId: NumeroriShoqerimi.Ipashoqeruarmeemer, gjiniaId: NumeroriGjinia.Femerore, rasaId: NumeroriRasa.Rrjedhore, left: 'të' }
  ]

  public static NumeroriThyesatMeNumeruesNjeStructure = [
    { rasaId: NumeroriRasa.Emerore, left: 'një', middle: 'e' },
    { rasaId: NumeroriRasa.Gjinore, left: 'një', middle: 'së' },
    { rasaId: NumeroriRasa.Dhanore, left: 'një', middle: 'së' },
    { rasaId: NumeroriRasa.Kallezore, left: 'një', middle: 'të' },
    { rasaId: NumeroriRasa.Rrjedhore, left: 'një', middle: 'së' },
  ]

  public static NumeroriThyesatMeNumeruesDyeSiperStructure = [
    { rasaId: NumeroriRasa.Emerore, middle: 'të' },
    { rasaId: NumeroriRasa.Gjinore, middle: 'të' },
    { rasaId: NumeroriRasa.Dhanore, middle: 'të' },
    { rasaId: NumeroriRasa.Kallezore, middle: 'të' },
    { rasaId: NumeroriRasa.Rrjedhore, middle: 'të' },
  ]


  public static GetFormulas(baza: string, kategoria: NumeroriKategoria) {
    switch (kategoria) {
      //1
      case NumeroriKategoria.njee: {
        let N1 = baza;
        let N2 = N1 + 'r';

        return { N1, N2 };
      }

      //2
      case NumeroriKategoria.dy: {
        let N1 = baza;
        let N2 = N1 + 'ja';

        return { N1, N2 };
      }

      //3
      case NumeroriKategoria.tre: {
        let N1 = baza;
        let N2 = N1.replaceLastOccurrence('e', 'i');
        let N3 = N2 + 'a';

        return { N1, N2, N3 };
      }

      //4
      case NumeroriKategoria.kateer: {
        let N1 = baza;
        let N2 = N1.replaceLastOccurrence('e', 'i');
        let N3 = N2 + 'a';

        return { N1, N2, N3 };
      }

      //6
      case NumeroriKategoria.gjashtee: {
        let N1 = baza;
        let N2 = N1.replaceLastOccurrence('ë', 'a');

        return { N1, N2 };
      }

      //20
      case NumeroriKategoria.njeezet: {
        let N1 = baza;
        let N2 = N1 + 'a';
        let N3 = N1 + 'ë'

        return { N1, N2, N3 };
      }

      //21
      case NumeroriKategoria.njeezetenjee: {
        let N1 = baza;
        let N2 = '';
        let N1Split = N1.split(' ');

        N1Split.forEach((item, index) => {
          if (item.slice(-1) == 'ë' && index == 0) {
            N2 = item.slice(0, -1);
          } else {
            N2 += item;
          }
        })

        let N3 = N2 + 'ta';

        return { N1, N2, N3 };
      }

      //22
      case NumeroriKategoria.njeezetedy: {
        let N1 = baza;
        let N2 = '';
        let N1Split = N1.split(' ');

        N1Split.forEach((item, index) => {
          if (item.slice(-1) == 'ë' && index == 0) {
            N2 = item.slice(0, -1);
          } else {
            N2 += item;
          }
        })

        let N3 = N2 + 'ja';

        return { N1, N2, N3 };
      }

      //23
      case NumeroriKategoria.njeezetetre: {
        let N1 = 'njëzet e tre';
        let N2 = 'njëzet e tri';
        let N3 = N1.replace(/\s/g, "").replace('ë', '');
        let N4 = N2.replace(/\s/g, "").replace('ë', '');

        return { N1, N2, N3, N4 };
      }

      //24
      case NumeroriKategoria.njeezetekateer: {
        let N1 = baza;
        let N2 = N1.replaceLastOccurrence('e', 'i');
        let N3 = N2 + 'a';

        return { N1, N2, N3 };
      }

      //26
      case NumeroriKategoria.njeezetegjashtee: {
        let N1 = baza;
        let N2 = N1.replace(/\s/g, "").replace('ë', '');
        let N3 = N2.replaceLastOccurrence('ë', 'a');

        return { N1, N2, N3 };
      }

      //Thyesat
      case NumeroriKategoria.Thyesatmenumeeruesnjee: {
        let N1 = baza;
        let N2 = N1.replaceLastOccurrence('a', 'ë');

        return { N1, N2 };
      }

      case NumeroriKategoria.Thyesatmenumeeruesdyesipeer: {
        let N1 = baza;
        let N2 = N1.replaceLastOccurrence('a', 'ë');

        return { N1, N2 };
      }
    }
  }
}
